import type { FC } from 'react';

import QuestionMarkCircle from '@crehana/compass.icons.outline/QuestionMarkCircle';
import { Switch } from '@crehana/compass.ui';
import {
  cn,
  Tag,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@crehana/compass.ui/v2';

import useAssignUserTranslation from '../hooks/useAssignUserTranslation';
import type { TTableAssign } from '../type';

const SwitchNotificationUsers: FC<
  Pick<TTableAssign, 'setIsCheckNotification' | 'isCheckNotification'> & {
    className?: string;
    tooltipMessage?: string;
  }
> = ({
  isCheckNotification,
  setIsCheckNotification,
  className,
  tooltipMessage,
}) => {
  const { t } = useAssignUserTranslation();

  return (
    <div
      className={cn('tw-ml-auto tw-flex tw-items-center tw-gap-0.8', className)}
    >
      <Tag variant="text" className="tw-font-semibold">
        {t('SWITCH_NOTIFICATION_NEW')}
      </Tag>
      <p className="tw-text-neutral-light-800 tw-font-semibold tw-font-subtitle6">
        {t('SWITCH_NOTIFICATION_TITLE')}
      </p>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger>
            <span>
              <QuestionMarkCircle
                size={16}
                className="tw-text-neutral-light-700"
              />
            </span>
          </TooltipTrigger>
          <TooltipContent align="center" side="top">
            {tooltipMessage || t('SWITCH_NOTIFICATION_MESSAGE')}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
      <Switch
        showLabel={false}
        label=""
        id="checkNotification"
        checked={isCheckNotification}
        onChange={() =>
          setIsCheckNotification && setIsCheckNotification(!isCheckNotification)
        }
        disabled={false}
      />
    </div>
  );
};

export default SwitchNotificationUsers;
